import { useTranslate } from 'hooks/useTranslate';
import { Document } from 'types';
import DocumentsRow from './components/DocumentsRow';
import DocumentsListHeader from './components/DocumentsListHeader';

type Props = {
  documents: (Document | File)[];
};

const DocumentsList = ({ documents }: Props) => {
  const { t } = useTranslate();

  return (
    <div className="g-2">
      <div>
        <h5 className="nk-block-title mb-0">{t('Documents')}</h5>
      </div>

      <div className="nk-files nk-files-view-list">
        <DocumentsListHeader />

        <div className="nk-files-list">
          {documents?.map((document, index) => (
            <DocumentsRow
              // eslint-disable-next-line
              key={`row-${index}`}
              index={index}
              document={document}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocumentsList;
